import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { ProgressSteps } from 'components/ProgressSteps/ProgressSteps';

const INTERVAL_TIME = 5 * 1000;

type Props = {
  shouldComplete: boolean;
  onComplete: () => void;
};

export const StoreSetupStepProgress: FC<Props> = ({ shouldComplete, onComplete }) => {
  const { t } = useTranslation();

  const [index, setIndex] = useState(0);

  const steps = [
    t('store-setup-step.progress.item.title.1'),
    t('store-setup-step.progress.item.title.2'),
    t('store-setup-step.progress.item.title.3'),
    t('store-setup-step.progress.item.title.4'),
    t('store-setup-step.progress.item.title.5'),
  ];

  const itemsCount = steps.length;

  useEffect(() => {
    if (index >= itemsCount) {
      setTimeout(onComplete, 1000);
    }
  }, [index, onComplete, itemsCount]);

  useEffect(() => {
    if (index >= itemsCount) {
      return;
    }

    const interval = setInterval(() => {
      setIndex((prev) => {
        return prev === itemsCount - 1 && !shouldComplete ? prev : prev + 1;
      });
    }, INTERVAL_TIME);

    return () => clearInterval(interval);
  }, [shouldComplete, index, itemsCount]);

  return (
    <ProgressSteps
      currentStepIndex={index}
      steps={[
        t('store-setup-step.progress.item.title.1'),
        t('store-setup-step.progress.item.title.2'),
        t('store-setup-step.progress.item.title.3'),
        t('store-setup-step.progress.item.title.4'),
        t('store-setup-step.progress.item.title.5'),
      ]}
    />
  );
};
